// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3a0ad52c","498":"94b71f2e","703":"b87ff12a"}[chunkId] + ".chunk.js";
};